<template>
    <div>
        <div class="h30"></div>
        <div class="center1200 bg-white shadow" >
            <div style="padding:30px 50px;">

            <div class="center-title"><img class="title-pic" src="/static/img/title-left.png" alt=""> 完成问卷 <img class="title-pic" src="/static/img/title-right.png" alt=""></div>
            <div class="h30"></div>
            <div v-for="v,k in test">
                <div></div>
                <div>{{k+1}}、{{v.quiz}}</div>
                <el-radio-group v-model="answer[v.id]">
                    <div class="h20"></div>
                    <el-radio label="A">{{v.A}}</el-radio>
                    <div class="h20"></div>
                    <el-radio label="B">{{v.B}}</el-radio>
                    <div class="h20"></div>
                    <el-radio label="C">{{v.C}}</el-radio>
                    <div class="h20"></div>
                    <el-radio label="D">{{v.D}}</el-radio>
                    <div class="h20"></div>
                </el-radio-group>
                
            </div>
            <div class="h30"></div>
            <div style="text-align: center;">

                <el-button type="primary" @click="postAnswer()">提 交</el-button>
                <el-button type="primary" @click="go()">返 回</el-button>
            </div>
            </div>
            <Goback></Goback>

        </div>
        <div class="h30"></div>
    </div>
</template>
<script>
    import Goback from '@/components/components/goback'
    export default{
        
components:{
            Goback,

        },
        data(){
            return{
                //试题
                test:{},
                //提交的答案
                answer:[],
            }
        },
        mounted(){
            this.getTest();

        },
        methods:{
            getTest(){
                $.ajax({
                url:"//" + this.$API_URL + "/api/v1/quiz",
                type:"get",
                success:(ret)=>{
                    if(ret.code==200){
                        this.test = ret.data
                    }
                }
                })
            },
            postAnswer(){
                if(this.answer.length<5){
                    this.$message({
                        showClose:true,
                        message:"请做完试题再提交呀┏(゜ロ゜;)┛",
                        type:"error"
                    })
                    return false;
                }
                
                $.ajax({
                    url:"//"+ this.$API_URL +"/api/v1/quiz/answer",
                    type:"post",
                    data:{1:this.answer[1],2:this.answer[2],3:this.answer[3],4:this.answer[4],5:this.answer[5],user_id:localStorage.getItem('token')},
                    success:(ret)=>{
                        if(ret.data!=null){
                            var wrong = (100 - ret.data) / 20
                            this.$message({
                                showClose:true,
                                message:"有"+wrong+"题错啦~ 再想想呀~（・(ｪ)・）",
                                type:"error"
                            })
                        }else{
                            this.$message({
                                showClose:true,
                                message:"恭喜你~全对啦~可以评论了哟~(*￣∇￣*)",
                                type:"success"
                            })
                            this.$parent.user_level = 1
                            setTimeout(()=> { 
                                this.$router.go(-1);
                            },1500);
                        }
                        
                        
                    }
                })
                    
            
            },
            go(){
                this.$router.go(-1);

            }
        
        }
    }
</script>
<style>
    
</style>



// WEBPACK FOOTER //
// src/components/index/test.vue